import WarehouseShipmentPanel from '../components/WarehouseShipmentPanel';
import ProductIdentity from '../components/ProductIdentity';
import React, { useState, useEffect, useCallback } from 'react';
import api, { logoutSession } from '../api';
import { FULFILLMENT_STATUS_LABELS as STATUS_LABELS, COLLECTOR_NEXT_ACTION } from '../constants/fulfillmentStatus';

function CollectorDashboard() {
  const [collector, setCollector] = useState(() => {
    const saved = localStorage.getItem('collector');
    const accessToken = localStorage.getItem('collectorAccessToken');
    const refreshToken = localStorage.getItem('collectorRefreshToken');
    if (!saved || !accessToken || !refreshToken) {
      localStorage.removeItem('collector');
      localStorage.removeItem('collectorAccessToken');
      localStorage.removeItem('collectorRefreshToken');
      return null;
    }
    try {
      const parsed = JSON.parse(saved);
      if (!parsed?.id) throw new Error('Некорректные данные сборщика');
      return parsed;
    } catch {
      localStorage.removeItem('collector');
      localStorage.removeItem('collectorAccessToken');
      localStorage.removeItem('collectorRefreshToken');
      return null;
    }
  });
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [orders, setOrders] = useState([]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const res = await api.post('/api/collector/login', { phone: phone.trim(), password });
      const { collector: collectorData, accessToken, refreshToken } = res.data;
      if (!collectorData?.id || !accessToken || !refreshToken) {
        throw new Error('Сервер вернул некорректные данные авторизации');
      }
      localStorage.setItem('collector', JSON.stringify(collectorData));
      localStorage.setItem('collectorAccessToken', accessToken);
      localStorage.setItem('collectorRefreshToken', refreshToken);
      setCollector(collectorData);
    } catch (err) {
      setError(err.response?.data?.error || err.message || 'Ошибка входа');
    }
  };

  const handleLogout = async () => {
    await logoutSession('collector');
    setCollector(null);
    setOrders([]);
  };

  const loadOrders = useCallback(async () => {
    if (!collector) return;
    try {
      const res = await api.get(`/api/collector/orders/${collector.id}`);
      setOrders(res.data);
    } catch (err) {
      console.error(err);
    }
  }, [collector]);

  const updateStatus = async (orderId, status) => {
    try {
      await api.patch(`/api/collector/orders/${orderId}/status`, { status });
      loadOrders();
    } catch (err) {
      alert('Ошибка обновления статуса');
    }
  };

  useEffect(() => {
    if (collector) loadOrders();
  }, [collector, loadOrders]);

  if (!collector) {
    return (
      <div style={{ maxWidth: 400, margin: '40px auto', background: 'white', borderRadius: 16, padding: 32, boxShadow: '0 8px 24px rgba(0,0,0,0.08)' }}>
        <h2 style={{ textAlign: 'center', marginBottom: 20, color: '#1e293b' }}>Вход сборщика</h2>
        {error && <p style={{ color: 'red', marginBottom: 10 }}>{error}</p>}
        <form onSubmit={handleLogin}>
          <input placeholder="Телефон" value={phone} onChange={e => setPhone(e.target.value)} required
            style={{ width: '100%', padding: 12, marginBottom: 12, borderRadius: 8, border: '1px solid #e2e8f0' }} />
          <input placeholder="Пароль" type="password" value={password} onChange={e => setPassword(e.target.value)} required
            style={{ width: '100%', padding: 12, marginBottom: 12, borderRadius: 8, border: '1px solid #e2e8f0' }} />
          <button type="submit" className="btn btn-primary" style={{ width: '100%', padding: 12, fontWeight: 600 }}>Войти</button>
        </form>
      </div>
    );
  }

  return (
    <div className="operations-workspace" style={{ minHeight: '100vh', background: '#f8fafc' }}>
      <header style={{ background: 'linear-gradient(135deg, #4C1D95 0%, #7C3AED 100%)', color: 'white', padding: '14px 30px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <span style={{ fontSize: 24, fontWeight: 700 }}>MaxMarket — Сборщик: {collector.name}</span>
        <button onClick={handleLogout} className="btn btn-outline" style={{ color: 'white', borderColor: 'rgba(255,255,255,0.5)' }}>Выйти</button>
      </header>
      <div style={{ maxWidth: 1000, margin: '30px auto', padding: '0 20px' }}>
        <h2 style={{ fontWeight: 700, color: '#1e293b', marginBottom: 20 }}>Мои заказы</h2>
        {orders.length === 0 ? <p>Нет назначенных заказов</p> : orders.map(order => (
          <div key={order.id} style={{ background: 'white', borderRadius: 12, padding: 20, marginBottom: 16, boxShadow: '0 2px 8px rgba(0,0,0,0.04)' }}>
            <h3>Заказ №{order.id}</h3>
            <p><strong>Клиент:</strong> {order.customerName || '—'} | <strong>Телефон:</strong> {order.customerPhone}</p>
            <p><strong>Статус:</strong> {STATUS_LABELS[order.fulfillmentStatus] || order.fulfillmentStatus}</p>
            <WarehouseShipmentPanel order={order} role="collector" />
            {order.sellerOrders?.map(so => (
              <div key={so.id} style={{ marginTop: 12, padding: 12, background: '#f8fafc', borderRadius: 8 }}>
                <strong>Продавец: {so.seller?.name || `ID ${so.sellerId}`}</strong>
                <div className="product-table-scroll"><table style={{ width: '100%', borderCollapse: 'collapse', marginTop: 8 }}>
                  <thead>
                    <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                      <th style={{ textAlign: 'left', padding: '6px 0' }}>Товар</th>
                      <th style={{ textAlign: 'left', padding: '6px 0' }}>Размер</th>
                      <th style={{ textAlign: 'left', padding: '6px 0' }}>Кол-во</th>
                    </tr>
                  </thead>
                  <tbody>
                    {so.items?.map(item => (
                      <tr key={item.id} style={{ borderBottom: '1px solid #f1f5f9' }}>
                        <td style={{ padding: '6px 0' }}><ProductIdentity product={item} /></td>
                        <td style={{ padding: '6px 0' }}>{item.orderItem?.variant?.size || '—'}</td>
                        <td style={{ padding: '6px 0' }}>{item.quantity}</td>
                      </tr>
                    ))}
                  </tbody>
                </table></div>
              </div>
            ))}
            <div style={{ marginTop: 16, display: 'flex', gap: 8 }}>
              {COLLECTOR_NEXT_ACTION[order.fulfillmentStatus] && (
                <button onClick={() => updateStatus(order.id, COLLECTOR_NEXT_ACTION[order.fulfillmentStatus].target)} className="btn btn-primary">
                  {COLLECTOR_NEXT_ACTION[order.fulfillmentStatus].label}
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default CollectorDashboard;
